import React from "react";
import { AssessmentListItem } from "../../utils/interface/assessment";
import { Play } from "solar-icon-set/videoaudiosound";
import { Colors } from "../../utils/constants/colors";
import { Lock } from "solar-icon-set/security";
import './styles.css';
import { useUser } from "../../redux/useStore";

interface AssessmentCardProps {
    assessment: AssessmentListItem;
    onAssessmentClick: (assessment: AssessmentListItem) => void;
}


export default function AssessmentCard(props: AssessmentCardProps) {

    const { assessment, onAssessmentClick } = props;

    const localUser = useUser()

    return (
        <div className="assessment_card" onClick={() => onAssessmentClick(assessment)}>
            <div className="assessment_poster_holder">
                <img src={assessment.assessment_thumb || "https://t4.ftcdn.net/jpg/09/65/48/01/360_F_965480105_q4AYUoEgBBi4VcRr2SO8kcQ4FtY6KlKl.jpg"}
                    alt="poster"
                    className={`assessment_poster ${assessment.is_unlocked === false ? 'locked' : ''}`} />
            </div>

            <div className="assessment_detail_holder">
                <h2>{assessment.title}</h2>
                {localUser?.role === 'admin' && assessment.is_approved === false &&
                    <span className="assessment_review pending">
                        PENDING APPROVAL
                    </span>
                }

                <div className="assessment_detail_meta">
                    <div className="detail">

                        <span>
                            <strong>Duration - </strong>{assessment.time / 60} Hrs.
                        </span>

                        <span>
                            <strong>Marks - </strong>{assessment.total_marks}
                        </span>


                    </div>
                    {localUser?.role === 'student' ?
                        assessment.is_unlocked ?
                            <Play size={25} color={Colors.primary} />
                            :
                            <Lock size={25} color={Colors.primary} iconStyle='Bold' />

                        :
                        localUser?.role === 'admin' &&
                            assessment.is_approved === false ?
                            <Play size={25} color={Colors.yellow} iconStyle='Bold' />
                            :
                            <Play size={25} color={Colors.primary} />

                    }

                </div>
            </div>
        </div >
    )
}